<!-- 代理等级变更日志 -->
<template>
    <c-dialog ref="singinRecordDialog" :title="title" width="1200" height="800" enable-flex :button="false">
        <m-search ref="search" @search="search">
            <c-form ref="form" inline>
                <c-form-item type="datetime" label="签到时间" start-name="start_date" end-name="end_date"></c-form-item>
            </c-form>
        </m-search>
        <c-table ref="singinRecordTable" height="770">
            <c-table-column label="签到时间" name="create_date" width="155"></c-table-column>
            <c-table-column label="健康信息" name="health_info" width="450">
                <template v-slot="{data}">
                    <p v-for="(item,i) in data.health_info">
                        <span>{{item.key}}：{{item.value}}</span>
                    </p>
                </template>
            </c-table-column>
            <c-table-column label="健康报告" name="health_report" width="450"></c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>
	export default {
		props: {

        },

        data() {
            return {
                title:'代理调整记录',
                serachParams:{}
            }
        },
		
        methods: {
              search(data) {
                  data = Object.assign(data||{},this.serachParams),
                  this.$refs.singinRecordTable.load({
                      url: '/platform_user/singin/record',
                      data
                  });
              },

              open(params) {
                        this.serachParams = params||{};
                        if (params && params.title){
                            this.title = params.title;
                        }
                        this.$refs.singinRecordDialog.open();
                        this.$refs.singinRecordTable.load({
                            url: '/platform_user/singin/record',
                            data:this.serachParams
                        });
              }
        }
	}
</script>